export const chromaVectorSyncQueryRootKey = ["chroma_vector_sync", "targets"] as const;
